export default __webpack_public_path__ + "9dcb0b53f16ab73abd398deb6acf05d6.png";